import React, { useEffect, useState } from "react";
import "./PopupModal.css";

export default function PopupModal() {
  const [show, setShow] = useState(false);

  // Show popup every time page loads
  useEffect(() => {
    setShow(true);
  }, []);

  const closePopup = () => {
    setShow(false);
  };

  if (!show) return null;

  return (
    <div className="popup-overlay" onClick={closePopup}>
      <div
        className="popup-container"
        onClick={(e) => e.stopPropagation()}  // prevent close when clicking inside
      >
        <img src="./images/notice-popup.jpg" alt="Makreri Temple" />

        <button className="close-btn" onClick={closePopup}>
          X
        </button>
      </div>
    </div>
  );
}
